export default __webpack_public_path__ + "static/mining-39d7a800a9e1b01e81359f1eb6e63021.jpg";